var map = {
	"./yellowtree/accordion-item/block.tsx": 1470,
	"./yellowtree/accordion/block.tsx": 1641,
	"./yellowtree/angestellte-wrapper/block.tsx": 8188,
	"./yellowtree/button/block.tsx": 5629,
	"./yellowtree/card-2/block.tsx": 2596,
	"./yellowtree/card/block.tsx": 6819,
	"./yellowtree/column/block.tsx": 7827,
	"./yellowtree/contact-form-fuehrung/block.tsx": 6349,
	"./yellowtree/contact-form/block.tsx": 6265,
	"./yellowtree/download-link/block.tsx": 3630,
	"./yellowtree/footernav/block.tsx": 2639,
	"./yellowtree/full-two-column/block.tsx": 3620,
	"./yellowtree/header/block.tsx": 7307,
	"./yellowtree/header2/block.tsx": 1505,
	"./yellowtree/iconcard/block.tsx": 515,
	"./yellowtree/leitung-info/block.tsx": 3815,
	"./yellowtree/missionaries-wrapper/block.tsx": 7232,
	"./yellowtree/missionary-info/block.tsx": 928,
	"./yellowtree/mobile-slider/block.tsx": 567,
	"./yellowtree/navbar/block.tsx": 9680,
	"./yellowtree/news/block.tsx": 1217,
	"./yellowtree/newsletter/block.tsx": 5438,
	"./yellowtree/parallax-section/block.tsx": 1293,
	"./yellowtree/post-subline/block.tsx": 5188,
	"./yellowtree/post-tags/block.tsx": 5069,
	"./yellowtree/privacynav/block.tsx": 4983,
	"./yellowtree/profile-angestellte/block.tsx": 3267,
	"./yellowtree/profile-leitung/block.tsx": 3270,
	"./yellowtree/profile-missionary/block.tsx": 8645,
	"./yellowtree/read-more/block.tsx": 6540,
	"./yellowtree/row/block.tsx": 20,
	"./yellowtree/slider/block.tsx": 627,
	"./yellowtree/teacher-header/block.tsx": 6001,
	"./yellowtree/teaser-section/block.tsx": 844,
	"./yellowtree/teaser/block.tsx": 8961,
	"./yellowtree/text-slide/block.tsx": 5932,
	"./yellowtree/text-slider/block.tsx": 5756
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9151;